import React, { Component } from 'react'
import { connect } from "react-redux";
import iconRight from '../../../assets/images/Icon-arrow-right.png';
import Select from 'react-select';
import { savePurchaseOrder, addInventoryItems, } from "../../../store/actions";
import { DayPicker } from 'react-day-picker';
import { addYears, format, subDays } from "date-fns";
import { compact, uniq } from 'lodash';

class AddOrdersView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderDate: format(subDays(new Date(), 5), "MM/dd/yyyy"),
      invoiceDate: format(new Date(), "MM/dd/yyyy"),
      status: "Pending",
      isChecked: false,
      dataList: [],
      allSerial: [],
      loading: false,
      unrecordedOrders: [],
      clocksItems: [],
      systemOrder: {},
      isEdit: false,
      itemList: [],
      orderItems: {},
      validated: false,
      orderData: {},
    };
  };

  async componentDidMount() {
    this.setState({ loading: true, isEdit: this.props.isEdit, orderData: this.props.orderData });
    let unrecordedOrders = this.props.UNRECORDED_ORDERS?.map(ord => {
      return {
        value: ord.orderSystemId,
        label: `Order ID: ${ord.orderSystemId} | Order Date: ${new Date(ord.orderDate).toLocaleDateString()}`,
        ...ord
      }
    });
    if (this.props.isEdit) {
      let { inventoryItems } = this.props.orderData;

      this.setState({ itemList: inventoryItems });
    };

    let clocksItems = this.props.CLOCKS_ITEMS?.map(it => ({ ...it, value: it._id, label: it.itemName }));
    this.setState({ unrecordedOrders, clocksItems, loading: false });
  };

  addItem = () => {
    let item = {
      itemName: "",
      itemDescription: "",
      unitPrice: 0,
      qty: 1,
      serialStrings: "",
      serials: []
    };
    let { itemList } = this.state;
    itemList.push(item);
    this.setState({ itemList });
  }

  AddOrder = async () => {
    let { itemList, systemOrder } = this.state;
    let inventoryItems = [];
    itemList.forEach(item => {
      let { _id, serials } = item;
      serials.forEach(serial => {
        inventoryItems.push({
          clockItem: _id,
          serialNumber: serial,
          vendorWarrantyEndDate: Number(addYears(new Date(this.state.invoiceDate), 1)),
        });
      });
    });
    await this.props.addInventoryItems({ inventoryItems });
    let { orderSystemId, orderDate, invoiceDate } = systemOrder;
    let itemIds = this.props.ADD_INVENTORY_ITEMS.map(iIt => iIt._id);
    let orderPayload = {
      orderSystemId,
      orderDate: Number(new Date(orderDate)),
      invoiceDate: Number(new Date(invoiceDate)),
      inventoryItems: itemIds,
      orderType: "order"
    };
    await this.props.savePurchaseOrder(orderPayload);
    this.props.closeSidebar();
  };

  setSelectedOrder = (selected) => {
    let { orderDate, invoiceDate, } = selected;
    let systemOrder = selected;
    invoiceDate = invoiceDate || orderDate;

    this.setState({ systemOrder, orderDate, invoiceDate });
  };

  setSelectedItem = (selected, itemIdx) => {
    let { itemList } = this.state;
    itemList[itemIdx] = { ...itemList[itemIdx], ...selected }
    this.setState({ itemList });
  };

  qtyChange = (e, index) => {
    let qty = e.target.valueAsNumber;
    let { itemList } = this.state;
    let { serials } = itemList[index];
    this.validateSerials(serials, qty, index);
    itemList[index].qty = qty;
    this.setState({ itemList: [...itemList] });
  };

  serialChange = async (num, index) => {
    var serials = compact(num.split(',').map(s => s.trim()).filter(s => s.match(/[a-zA-Z0-9]/g)));
    let { itemList } = this.state;
    let { qty } = itemList[index]
    this.validateSerials(serials, qty, index);
    itemList[index].serials = serials;
    itemList[index].serialStrings = num;
    this.setState({ itemList: [...itemList] });
  };

  validateSerials = (serials, qty, index) => {
    if (qty === serials.length) {
      this.setState({ isError: false, });
    } else {
      if (qty > serials.length) {
        this.setState({ errIndex: index, isError: true, errMsg: `Please add ${qty - serials.length} more serial number or remove ${qty - serials.length} qty`, })
      } else {
        this.setState({ errIndex: index, isError: true, errMsg: `Please remove ${serials.length - qty} serial number or add ${serials.length - qty} qty`, })
      };
    };
  };
  render() {
    const { loading, unrecordedOrders, isEdit, orderData, isError, errMsg, errIndex, itemList } = this.state
    return (
      <>
        <div className={`AddPurchaseOrders`} >
          <div className="overlay-pop" onClick={this.props.closeSidebar}></div>
          {!loading && <div >
            <div className="userHeader d-flex align-items-center justify-content-between">
              <div className="UserName">
                <h2>Add Purchase Orders Detail</h2>
              </div>
              <div className="iconRight" onClick={this.props.closeSidebar}>
                <img src={iconRight} alt=""></img>
              </div>
            </div>
            <div className="item-body">
              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Order ID </span>
                </div>
                {isEdit ?
                  <div className="itemOutput">
                    <span>{orderData.orderSystemId}</span>
                  </div>
                  : <div className="itemOutput">
                    <Select
                      placeholder="Select Order"
                      options={unrecordedOrders}
                      onChange={this.setSelectedOrder}
                    />
                  </div>}
              </div>
              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Order Date</span>
                </div>
                {isEdit ?
                  <div className="itemOutput date-range">
                    <span>{orderData.orderDate}</span>
                  </div> :
                  <div className="itemOutput date-range">
                    <input
                      type={"text"}
                      value={new Date(this.state.orderDate).toLocaleDateString()}
                      onClick={() => this.setState({ showPurchase: !this.state.showPurchase })}
                    />
                    {this.state.showPurchase && <DayPicker
                      mode='single'
                      selected={new Date(this.state.orderDate)}
                      onDayClick={(day) => this.setState({ orderDate: day, showPurchase: false })}
                    />}
                  </div>}
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Invoice Date</span>
                </div>
                {isEdit ?
                  <div className="itemOutput date-range">
                    <span>{orderData.invoiceDate}</span>
                  </div>
                  :
                  <div className="itemOutput date-range">
                    <input
                      type={"text"}
                      value={new Date(this.state.invoiceDate).toLocaleDateString()}
                      onClick={() => this.setState({ showDelivery: !this.state.showDelivery })}
                    />
                    {this.state.showDelivery && <DayPicker
                      mode='single'
                      selected={new Date(this.state.invoiceDate)}
                      onDayClick={day => this.setState({ invoiceDate: day, showDelivery: false })}
                    />}
                  </div>}
              </div>

              {itemList.length ?
                <>
                  {itemList.map((item, index) =>
                    <>
                      <div className="itemList d-flex align-items-center justify-content-between">
                        <div className="itemLabel">
                          <span>Select Clock Item</span>
                        </div>
                        <div className="itemOutput text-start">
                          <Select
                            options={this.state.clocksItems}
                            onChange={(selected) => this.setSelectedItem(selected, index)}
                          />
                        </div>
                      </div>
                      <div className="itemList d-flex align-items-center justify-content-between">
                        <div className="itemLabel">
                          <span>Qty</span>
                        </div>
                        <div className="itemOutput text-start">
                          <input
                            type={'number'}
                            value={item.qty}
                            min="1"
                            step={"1"}
                            onChange={e => this.qtyChange(e, index)}
                          />

                        </div>
                      </div>
                      <div className="itemList d-flex align-items-center justify-content-between">
                        <div className="itemLabel">
                          <span>Enter Serial Numbers; Comma separated</span>
                        </div>
                        <div className="itemOutput text-start">
                          <input
                            type="text"
                            value={item.serialStrings}
                            onChange={e => this.serialChange(e.target.value, index)}
                          />
                          {isError && errIndex === index ? <p>{errMsg}</p> : null}
                        </div>
                      </div>

                    </>)}
                </> : ""}
              {!isEdit && <button
                onClick={() => this.addItem()}
              >
                Add Item
              </button>}

            </div>
            <div className="item-footer text-end">
              <button className="pop_wth_btn" onClick={this.props.closeSidebar}>Cancel</button>
              {!isEdit && <button
                className="save-btn"
                disabled={isError || !itemList.length}
                onClick={this.AddOrder} >Save</button>}
            </div>
          </div>}
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer, UsersReducer, InventoryItemsReducer, PurchaseOrderReducer }) => {
  let { UNRECORDED_ORDERS, PURCHASE_ORDER } = PurchaseOrderReducer;
  let { CLOCKS_ITEMS, ADD_INVENTORY_ITEMS } = InventoryItemsReducer;
  return { UserReducer, UsersReducer, UNRECORDED_ORDERS, PURCHASE_ORDER, CLOCKS_ITEMS, ADD_INVENTORY_ITEMS };
};

export default connect(mapStateToProps, {
  addInventoryItems,
  savePurchaseOrder
})(AddOrdersView);


